import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 1rem;
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.distantWindChime};
`;

export const Cell = styled.div`
  flex-grow: 1;
  flex-basis: 0;
  font-size: 0.75rem;
  text-align: center;
  align-self: center;
`;
